import { StartUp02Icon } from '@hugeicons/react'

import {
  LevelPlayStartCardJourney,
  LevelPlayStartHeading,
  LevelPlayStartHero
} from '@/shared/level-play/start-screen'
import { Button } from '@/shared/ui/Button'
import { confirmResetProgress } from '@/shared/ui/dialog'
import { LevelPlay } from '@/shared/ui/LevelPlay'

import { useLevelContext } from '../../context'

export const DigitalProductJourneyLevelsChallengesInitial = ({ step }) => {
  const {
    level,
    hearts,
    playableChallengesCount,
    onChallengeStart,
    journeyBlockRedo,
    onLevelReset: _onLevelReset
  } = useLevelContext()

  const onLevelReset = async () => {
    const result = await confirmResetProgress()
    if (result === 'reset') _onLevelReset()
    else if (result === 'continue') onChallengeStart()
  }

  return (
    // `customContent` faz deste componente o filho direto do form, então é ele
    // que precisa carregar a corrente de flex — sem isso a coluna dimensionaria
    // pelo conteúdo e o footer largaria a base.
    <div className="flex min-h-0 flex-1 flex-col">
      <LevelPlay.Body
        id={step.id}
        className="flex flex-col items-center justify-center px-4"
      >
        <div className="flex w-full flex-col items-center gap-4">
          <LevelPlayStartHero variant="journey" />
          <LevelPlayStartHeading
            hearts={hearts}
            challengeCount={playableChallengesCount}
          />
        </div>
        {level && (
          <LevelPlayStartCardJourney
            className="mt-10"
            name={level.name}
            challengeCount={playableChallengesCount}
            pointReward={level.total_point_reward}
            coinReward={level.total_coin_reward}
          />
        )}
      </LevelPlay.Body>
      <LevelPlay.Footer id={step.id}>
        {!journeyBlockRedo && level?._levelContinue && (
          <Button variant="ghost" size="md" onClick={onLevelReset}>
            Recomeçar
          </Button>
        )}
        <Button
          variant="primary"
          size="md"
          className="grow"
          leadingIcon={<StartUp02Icon variant="duotone" size={20} />}
          onClick={onChallengeStart}
        >
          {level?._levelContinue ? 'Continuar' : 'Sim, começar!'}
        </Button>
      </LevelPlay.Footer>
    </div>
  )
}
